import { get, post } from '@barbanet/api-service'

import {
	OperatorRoleResponse,
	SwitchWorkspaceRequest,
	UserMeResponse
} from '../types/dto/user'

export const userMeService = () => get<UserMeResponse>('user', 'users/me')

export const getCurrentRoleService = () =>
	get<OperatorRoleResponse>('core', 'operators/current-role')

export const getRoleListService = () =>
	get<OperatorRoleResponse[]>('core', 'operators/roles')

export const postSwitchWorkspaceService = (companyId: string) =>
	post<SwitchWorkspaceRequest, BarbanetCredentials>(
		'uaa',
		'connect/switch-workspace',
		{ data: { companyId } }
	)
